import { generate } from "shortid";
import { PAGE_THEMES } from "../types";

export const MOBILE_PAYMENT_PAGES = {
  mobile_payment__page: {
    id: `mobile_payment__page-${generate()}`,
    type: "mobile_payment_type",
    target_state: "mobile_payment_data",
    theme: PAGE_THEMES.LIGHT,
    data: {
      default_progression: "mobile_payment__success_page",
    },
  },
  mobile_payment__success_page: {
    id: `mobile_payment__success_page-${generate()}`,
    type: "mobile_payment__success_type",
    target_state: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      default_progression: null,
    },
  },
};
